import React from "react"
import { StructuredText } from "react-datocms"

import Avatar from "../../design-system/avatar"
import Header from "../../design-system/header"
import Paragraph from "../../design-system/paragraph"
import { classNames } from "../../utils/class-names"
import { useLocale } from "../../utils/hooks/use-locale"
import { datoInlineLink } from "../structured-text-with-link/utils"
import * as styles from "./index.module.scss"
import { DatoCmsPullQuoteBlock } from "./types"

const DatoPullQuoteBlock = ({
  avatar,
  quote,
  name,
  title,
}: DatoCmsPullQuoteBlock) => {
  const locale = useLocale()
  return (
    <div className={classNames("block-pull-quote", styles.content)}>
      <Paragraph variant="1" className={styles.quote}>
        <StructuredText
          data={quote}
          renderInlineRecord={record => datoInlineLink(record, locale)}
        />
      </Paragraph>
      <div className={styles.author}>
        {avatar && <Avatar url={avatar.url} name={name} variant="medium" />}
        <div className={styles.aboutAuthor}>
          {name && (
            <Header className={styles.name} as="h4" variant="5">
              {name}
            </Header>
          )}
          {title && <Paragraph variant="2">{title}</Paragraph>}
        </div>
      </div>
    </div>
  )
}

export default DatoPullQuoteBlock
